import { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {
  FilterOptions,
  ReportDatePickerProps,
  SortOptions,
  SortOrderType,
} from '../interface/interface';
import { SingleValue } from 'react-select';
import OrderDateRangeFilter from './OrderDateRangeFilter';
import OrderSort from './OrderSort';
import moment from 'moment';

const ReportsDatePicker = (props: ReportDatePickerProps) => {
  const [fromDate, setFromDate] = useState<Date | null>(props.from ?? null);
  const [toDate, setToDate] = useState<Date | null>(props.to ?? null);
  const [filterBy] = useState<SingleValue<{ label: string; value: string }>>({
    label: 'Date',
    value: '',
  });

  const [sort, setSort] = useState<SortOrderType>(
    (localStorage.getItem('sortOrder') as SortOrderType) || SortOptions.ASC,
  );

  const [orderFilter, setFilerBy] = useState(
    localStorage.getItem('filterBy') || FilterOptions.CreatedDate,
  );

  const isDateInRange = (date: Date) => {
    const threeMonthsAgo = new Date();
    threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);

    return date >= threeMonthsAgo && date <= new Date();
  };

  const handleFromDateChange = (date: Date | null) => {
    if (date && isDateInRange(date)) {
      const startOfFromDate = moment(date).startOf('day').toDate();
      setFromDate(startOfFromDate);
      if (toDate) {
        props.onExport(startOfFromDate, toDate, filterBy?.value);
      }
      if (props.keyStores.from !== '')
        localStorage.setItem(
          props.keyStores.from,
          startOfFromDate.toISOString(),
        );
    }
  };

  const handleToDateChange = (date: Date | null) => {
    if (date && isDateInRange(date) && (!fromDate || date >= fromDate)) {
      const endOfToDate = moment(date).endOf('day').toDate();
      setToDate(endOfToDate);
      if (fromDate) {
        props.onExport(fromDate, endOfToDate, filterBy?.value);
      }
      if (props.keyStores.to !== '')
        localStorage.setItem(props.keyStores.to, endOfToDate.toISOString());
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newSortOrder = e.target.value as SortOrderType;
    localStorage.setItem('sortOrder', newSortOrder);
    setSort(newSortOrder);
    if (props.setSortOrder) props.setSortOrder(newSortOrder);
  };

  useEffect(() => {
    if (sort)
      setSort((localStorage.getItem('orderSort') as SortOrderType) || sort);
  }, [sort, localStorage.getItem('sortOrder')]);

  useEffect(() => {
    if (props.filterBy) {
      setFilerBy(
        (localStorage.getItem('filterBy') as string) || props.filterBy,
      );
    }
  }, [props.filterBy, localStorage.getItem('filterBy')]);

  return (
    <div className="flex flex-col md:flex-row md:items-center">
      {!props.order && (
        <div className="flex items-center">
          <div className="flex items-center">
            <label className="mr-3 text-sm text-primary-blue-500">From</label>
            <DatePicker
              selected={fromDate}
              onChange={handleFromDateChange}
              dateFormat="dd/MM/yyyy"
              maxDate={toDate || new Date()}
              minDate={new Date(new Date().setMonth(new Date().getMonth() - 3))}
              className="border border-solid rounded text-xs p-3 w-full shadow-0"
            />
          </div>

          <div className="flex items-center">
            <label className="mx-3 text-sm text-primary-blue-500">To</label>
            <DatePicker
              selected={toDate}
              onChange={handleToDateChange}
              dateFormat="dd/MM/yyyy"
              minDate={fromDate}
              maxDate={new Date()}
              className="border border-solid rounded text-xs p-3 w-full outline-0"
            />
          </div>
        </div>
      )}

      <div className="flex">
        {props.order ? (
          <OrderDateRangeFilter
            onExport={props.onExport}
            filterProp={{ state: orderFilter, setter: setFilerBy }}
          />
        ) : (
          <button
            className="md:ml-10 bg-primary-blue-500 text-white font-semibold text-sm px-3 py-2 mx-auto rounded mt-5 md:mt-0"
            onClick={() =>
              fromDate && toDate ? props.onExport(fromDate, toDate) : null
            }
          >
            {props.btnText ?? 'Export Report'}
          </button>
        )}
        <div className="flex items-center ml-3">
          <button
            className={` ${
              props.order
                ? 'border-b md:mt-0 pb-[2px]'
                : 'px-3 py-2 border rounded  mt-5 md:mt-0'
            } bg-white border-b border-primary-blue-500 text-primary-blue-500 font-semibold text-sm mx-auto `}
            onClick={() => {
              props.onClear();
              setFromDate(null);
              setToDate(null);
              if (props?.setFirstOrderFilter) {
                props.setFirstOrderFilter(false);
              }
              if (props?.setguestOrderFilter) {
                props.setguestOrderFilter(false);
              }
              if (props.order) {
                localStorage.setItem('filterBy', FilterOptions.CreatedDate);
                localStorage.setItem('sortOrder', SortOptions.DESC);
                setSort(SortOptions.DESC);
                setFilerBy(FilterOptions.CreatedDate);
                localStorage.removeItem('fromDate');
                localStorage.removeItem('toDate');
              }
            }}
          >
            Clear
          </button>
        </div>

        {props.order && props.setSortOrder && (
          <OrderSort sortprops={{ state: sort, action: handleChange }} />
        )}
      </div>
    </div>
  );
};

export default ReportsDatePicker;
